import { globalAccount } from './local-storage/global-account';
import { singleAccountDropdown } from './hierarchy-dropdown-service/single-account-dropdown-response';
import { hierarchyData } from './hierarchy-dropdown-service/single-account-dropdown-response';

export const localStorageMockData = { globalAccount: globalAccount };

export const hierarchyDropdownMockData = { singleAccountDropdown: singleAccountDropdown };

export const customHierarchyMockData = { customHierarchyData: hierarchyData };
